// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"e6c60da8","349":"e6c60da8"}[chunkId] + ".chunk.css";
};